<template>
<div class="mb-3">
  <VuePerfectScrollbar class="team-table-holder" >
    <b-table responsive :fields="fields" :items="items" :per-page="perPage" :current-page="currentPage">
      <template v-slot:cell(team)="data">
        {{ data.item.team.name }}
      </template>
      <template v-slot:cell(visits)="data">
        {{ data.item.visits | currency({fractionCount:0, symbol:''}) }}
      </template>
      <template v-slot:cell(sales)="data">
        {{ data.item.sales | currency({fractionCount:0, symbol:''}) }}
      </template>
      <template v-slot:cell(effectiveness)="data">
        {{ data.item.effectiveness | currency({symbol:'%', symbolSpacing:false, symbolPosition:'back'}) }}
      </template>
    </b-table>
  </VuePerfectScrollbar>
  <b-pagination v-show="items.length>perPage && perPage>0" :total-rows="items.length" :per-page="perPage" v-model="currentPage" class="justify-content-center" />
</div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
  props: ['items', 'fields', 'table-caption', 'symbol', 'per-page'],
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      currentPage: 1
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// EffectivenessTable.vue?19570395